<script>
export default {
  name: "MetricItem",
  props: {
    title: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    }
  }
}
</script>

<template>
  <div class="br flex justify-between mb-2">
    <span class="font-bold uppercase">{{title}}</span>
    <span class="flex items-center gap-2">
      {{value}}
      <slot name="button"></slot>
    </span>
  </div>
</template>

<style scoped>
.br {
  border-bottom: 1px solid #ebebed;
}
</style>